/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface FieldReportService {
  /** @summary Get Field Report */
  getFieldReport: {
    /** @summary Get Field Report */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetFieldReportSchema, GetFieldReportParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetFieldReportParameters, TMeta, TSignal>,
      client?: (
        schema: GetFieldReportSchema,
        options: {
          parameters: GetFieldReportParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetFieldReportData, GetFieldReportError>>
    ): Promise<RequestFnResponse<GetFieldReportData, GetFieldReportError>>;
    /** @summary Get Field Report */
    getQueryKey(
      parameters: DeepReadonly<GetFieldReportParameters>
    ): ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.fieldReportService.getFieldReport.useQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetFieldReportData>(
      parameters:
        | ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetFieldReportData,
          GetFieldReportError,
          TData,
          ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetFieldReportError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.fieldReportService.getFieldReport.useQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetFieldReportData>(
      parameters:
        | ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetFieldReportData,
          GetFieldReportError,
          TData,
          ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetFieldReportError>>;
    /** @summary Get Field Report */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetFieldReportParameters>
    ): ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.fieldReportService.getFieldReport.useInfiniteQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetFieldReportParameters,
      TQueryFnData = GetFieldReportData,
      TData = OperationInfiniteData<TQueryFnData, GetFieldReportParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetFieldReportError,
          TData,
          ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetFieldReportError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.fieldReportService.getFieldReport.useInfiniteQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetFieldReportParameters,
      TQueryFnData = GetFieldReportData,
      TData = OperationInfiniteData<TQueryFnData, GetFieldReportParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetFieldReportError,
          TData,
          ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetFieldReportData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetFieldReportError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getFieldReportTotal = qraft.fieldReportService.getFieldReport.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getFieldReportByParametersTotal = qraft.fieldReportService.getFieldReport.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getFieldReportResults = qraft.fieldReportService.getFieldReport.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getFieldReportResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getFieldReportCombinedResults = qraft.fieldReportService.getFieldReport.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getFieldReportCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetFieldReportSchema,
          GetFieldReportParameters,
          GetFieldReportData,
          GetFieldReportError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetFieldReportData, GetFieldReportError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetFieldReportData, GetFieldReportError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.fieldReportService.getFieldReport.useSuspenseQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetFieldReportData>(
      parameters:
        | ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetFieldReportData,
          GetFieldReportError,
          TData,
          ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetFieldReportError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.fieldReportService.getFieldReport.useSuspenseInfiniteQuery({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetFieldReportParameters, TData = GetFieldReportData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetFieldReportData,
          GetFieldReportError,
          OperationInfiniteData<TData, GetFieldReportParameters>,
          ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetFieldReportData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetFieldReportParameters>,
      OperationError<GetFieldReportError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getFieldReportData = qraft.fieldReportService.getFieldReport.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getFieldReportResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getFieldReportCombinedData = qraft.fieldReportService.getFieldReport.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 service_event_id: serviceEventId1
     *             }
     *         },
     *         {
     *             path: {
     *                 service_event_id: serviceEventId2
     *             }
     *         }
     *     ]
     * });
     * getFieldReportCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetFieldReportSchema,
          GetFieldReportParameters,
          GetFieldReportData,
          GetFieldReportError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetFieldReportData, GetFieldReportError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetFieldReportData, GetFieldReportError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Field Report */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetFieldReportSchema,
        GetFieldReportData,
        GetFieldReportParameters,
        GetFieldReportError
      >
    ): Promise<GetFieldReportData>;
    /** @summary Get Field Report */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetFieldReportSchema,
        GetFieldReportData,
        GetFieldReportParameters,
        GetFieldReportError
      >
    ): Promise<void>;
    /** @summary Get Field Report */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetFieldReportSchema,
        GetFieldReportData,
        GetFieldReportParameters,
        GetFieldReportError
      >
    ): Promise<GetFieldReportData>;
    /** @summary Get Field Report */
    fetchInfiniteQuery<TPageParam extends GetFieldReportParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetFieldReportSchema,
        GetFieldReportData,
        GetFieldReportParameters,
        DeepReadonly<TPageParam>,
        GetFieldReportError
      >
    ): Promise<OperationInfiniteData<GetFieldReportData, GetFieldReportParameters>>;
    /** @summary Get Field Report */
    prefetchInfiniteQuery<TPageParam extends GetFieldReportParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetFieldReportSchema,
        GetFieldReportData,
        GetFieldReportParameters,
        DeepReadonly<TPageParam>,
        GetFieldReportError
      >
    ): Promise<void>;
    /** @summary Get Field Report */
    ensureInfiniteQueryData<TPageParam extends GetFieldReportParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetFieldReportSchema,
        GetFieldReportData,
        GetFieldReportParameters,
        DeepReadonly<TPageParam>,
        GetFieldReportError
      >
    ): Promise<OperationInfiniteData<GetFieldReportData, GetFieldReportParameters>>;
    /** @summary Get Field Report */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>
    ): GetFieldReportData | undefined;
    /** @summary Get Field Report */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>
    ): OperationInfiniteData<GetFieldReportData, GetFieldReportParameters> | undefined;
    /** @summary Get Field Report */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
            data: NoInfer<OperationInfiniteData<GetFieldReportData, GetFieldReportParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
            data: GetFieldReportData | undefined,
          ]
        >;
    /** @summary Get Field Report */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>
        | DeepReadonly<GetFieldReportParameters>
    ): QueryState<GetFieldReportData, GetFieldReportError> | undefined;
    /** @summary Get Field Report */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetFieldReportParameters>
        | ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>
    ): QueryState<OperationInfiniteData<GetFieldReportData, GetFieldReportParameters>, GetFieldReportError> | undefined;
    /** @summary Get Field Report */
    setQueryData(
      parameters:
        | DeepReadonly<GetFieldReportParameters>
        | ServiceOperationQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
      updater: Updater<NoInfer<GetFieldReportData> | undefined, NoInfer<DeepReadonly<GetFieldReportData>> | undefined>,
      options?: SetDataOptions
    ): GetFieldReportData | undefined;
    /** @summary Get Field Report */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetFieldReportParameters>
        | ServiceOperationInfiniteQueryKey<GetFieldReportSchema, GetFieldReportParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetFieldReportData, GetFieldReportParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetFieldReportData, GetFieldReportParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetFieldReportData, GetFieldReportParameters> | undefined;
    /** @summary Get Field Report */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >,
      updater: Updater<NoInfer<GetFieldReportData> | undefined, NoInfer<GetFieldReportData> | undefined>,
      options?: SetDataOptions
    ): Array<GetFieldReportData | undefined>;
    /** @summary Get Field Report */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetFieldReportSchema,
        GetFieldReportData,
        TInfinite,
        GetFieldReportParameters,
        GetFieldReportError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Field Report */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Field Report */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Field Report */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
    ): void;
    /** @summary Get Field Report */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Field Report */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
        | QueryFiltersByQueryKey<
            GetFieldReportSchema,
            GetFieldReportData,
            TInfinite,
            GetFieldReportParameters,
            GetFieldReportError
          >
    ): number;
    schema: GetFieldReportSchema;
    types: {
      parameters: GetFieldReportParameters;
      data: GetFieldReportData;
      error: GetFieldReportError;
    };
  };
  /** @summary Create Field Report */
  createFieldReport: {
    /** @summary Create Field Report */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateFieldReportBody, CreateFieldReportParameters, TMeta, TSignal>,
      client?: (
        schema: CreateFieldReportSchema,
        options: ServiceOperationMutationFnOptions<CreateFieldReportBody, CreateFieldReportParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateFieldReportData, CreateFieldReportError>>
    ): Promise<RequestFnResponse<CreateFieldReportData, CreateFieldReportError>>;
    /** @summary Create Field Report */
    getMutationKey(
      parameters: DeepReadonly<CreateFieldReportParameters> | void
    ): ServiceOperationMutationKey<CreateFieldReportSchema, CreateFieldReportParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.createFieldReport.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.createFieldReport.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CreateFieldReportBody, TContext = unknown>(
      parameters: DeepReadonly<CreateFieldReportParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateFieldReportSchema,
        CreateFieldReportData,
        CreateFieldReportParameters,
        TVariables,
        OperationError<CreateFieldReportError>,
        TContext
      >
    ): UseMutationResult<CreateFieldReportData, OperationError<CreateFieldReportError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.createFieldReport.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.createFieldReport.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateFieldReportBody, CreateFieldReportParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateFieldReportSchema,
        CreateFieldReportData,
        CreateFieldReportParameters,
        TVariables,
        OperationError<CreateFieldReportError>,
        TContext
      >
    ): UseMutationResult<CreateFieldReportData, OperationError<CreateFieldReportError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createFieldReportTotal = qraft.fieldReportService.createFieldReport.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createFieldReportTotal = qraft.fieldReportService.createFieldReport.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateFieldReportBody,
            CreateFieldReportData,
            CreateFieldReportParameters,
            OperationError<CreateFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateFieldReportSchema,
            CreateFieldReportBody,
            CreateFieldReportData,
            CreateFieldReportParameters,
            OperationError<CreateFieldReportError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createFieldReportPendingMutationVariables = qraft.fieldReportService.createFieldReport.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createFieldReportMutationData = qraft.fieldReportService.createFieldReport.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateFieldReportData,
        OperationError<CreateFieldReportError>,
        MutationVariables<CreateFieldReportBody, CreateFieldReportParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateFieldReportBody,
            CreateFieldReportData,
            CreateFieldReportParameters,
            OperationError<CreateFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateFieldReportSchema,
            CreateFieldReportBody,
            CreateFieldReportData,
            CreateFieldReportParameters,
            OperationError<CreateFieldReportError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateFieldReportData,
          OperationError<CreateFieldReportError>,
          MutationVariables<CreateFieldReportBody, CreateFieldReportParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Field Report */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateFieldReportBody,
            CreateFieldReportData,
            CreateFieldReportParameters,
            OperationError<CreateFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateFieldReportSchema,
            CreateFieldReportBody,
            CreateFieldReportData,
            CreateFieldReportParameters,
            OperationError<CreateFieldReportError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.fieldReportService.createFieldReport.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.fieldReportService.createFieldReport.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateFieldReportBody,
              CreateFieldReportData,
              CreateFieldReportParameters,
              OperationError<CreateFieldReportError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateFieldReportSchema,
              CreateFieldReportBody,
              CreateFieldReportData,
              CreateFieldReportParameters,
              OperationError<CreateFieldReportError>,
              TContext
            >
      ):
        | Mutation<
            CreateFieldReportData,
            CreateFieldReportError,
            MutationVariables<CreateFieldReportBody, CreateFieldReportParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateFieldReportBody,
              CreateFieldReportData,
              CreateFieldReportParameters,
              OperationError<CreateFieldReportError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateFieldReportSchema,
              CreateFieldReportBody,
              CreateFieldReportData,
              CreateFieldReportParameters,
              OperationError<CreateFieldReportError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateFieldReportData,
          CreateFieldReportError,
          MutationVariables<CreateFieldReportBody, CreateFieldReportParameters>,
          TContext
        >
      >;
    };
    schema: CreateFieldReportSchema;
    types: {
      parameters: CreateFieldReportParameters;
      data: CreateFieldReportData;
      error: CreateFieldReportError;
      body: CreateFieldReportBody;
    };
  };
  /** @summary Update Field Report */
  updateFieldReport: {
    /** @summary Update Field Report */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateFieldReportBody, UpdateFieldReportParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateFieldReportSchema,
        options: ServiceOperationMutationFnOptions<UpdateFieldReportBody, UpdateFieldReportParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateFieldReportData, UpdateFieldReportError>>
    ): Promise<RequestFnResponse<UpdateFieldReportData, UpdateFieldReportError>>;
    /** @summary Update Field Report */
    getMutationKey(
      parameters: DeepReadonly<UpdateFieldReportParameters> | void
    ): ServiceOperationMutationKey<UpdateFieldReportSchema, UpdateFieldReportParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.updateFieldReport.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.updateFieldReport.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateFieldReportBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateFieldReportParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateFieldReportSchema,
        UpdateFieldReportData,
        UpdateFieldReportParameters,
        TVariables,
        OperationError<UpdateFieldReportError>,
        TContext
      >
    ): UseMutationResult<UpdateFieldReportData, OperationError<UpdateFieldReportError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.updateFieldReport.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.updateFieldReport.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateFieldReportBody, UpdateFieldReportParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateFieldReportSchema,
        UpdateFieldReportData,
        UpdateFieldReportParameters,
        TVariables,
        OperationError<UpdateFieldReportError>,
        TContext
      >
    ): UseMutationResult<UpdateFieldReportData, OperationError<UpdateFieldReportError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateFieldReportTotal = qraft.fieldReportService.updateFieldReport.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateFieldReportTotal = qraft.fieldReportService.updateFieldReport.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateFieldReportBody,
            UpdateFieldReportData,
            UpdateFieldReportParameters,
            OperationError<UpdateFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateFieldReportSchema,
            UpdateFieldReportBody,
            UpdateFieldReportData,
            UpdateFieldReportParameters,
            OperationError<UpdateFieldReportError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateFieldReportPendingMutationVariables = qraft.fieldReportService.updateFieldReport.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateFieldReportMutationData = qraft.fieldReportService.updateFieldReport.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateFieldReportData,
        OperationError<UpdateFieldReportError>,
        MutationVariables<UpdateFieldReportBody, UpdateFieldReportParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateFieldReportBody,
            UpdateFieldReportData,
            UpdateFieldReportParameters,
            OperationError<UpdateFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateFieldReportSchema,
            UpdateFieldReportBody,
            UpdateFieldReportData,
            UpdateFieldReportParameters,
            OperationError<UpdateFieldReportError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateFieldReportData,
          OperationError<UpdateFieldReportError>,
          MutationVariables<UpdateFieldReportBody, UpdateFieldReportParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update Field Report */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateFieldReportBody,
            UpdateFieldReportData,
            UpdateFieldReportParameters,
            OperationError<UpdateFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateFieldReportSchema,
            UpdateFieldReportBody,
            UpdateFieldReportData,
            UpdateFieldReportParameters,
            OperationError<UpdateFieldReportError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.fieldReportService.updateFieldReport.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.fieldReportService.updateFieldReport.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateFieldReportBody,
              UpdateFieldReportData,
              UpdateFieldReportParameters,
              OperationError<UpdateFieldReportError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateFieldReportSchema,
              UpdateFieldReportBody,
              UpdateFieldReportData,
              UpdateFieldReportParameters,
              OperationError<UpdateFieldReportError>,
              TContext
            >
      ):
        | Mutation<
            UpdateFieldReportData,
            UpdateFieldReportError,
            MutationVariables<UpdateFieldReportBody, UpdateFieldReportParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateFieldReportBody,
              UpdateFieldReportData,
              UpdateFieldReportParameters,
              OperationError<UpdateFieldReportError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateFieldReportSchema,
              UpdateFieldReportBody,
              UpdateFieldReportData,
              UpdateFieldReportParameters,
              OperationError<UpdateFieldReportError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateFieldReportData,
          UpdateFieldReportError,
          MutationVariables<UpdateFieldReportBody, UpdateFieldReportParameters>,
          TContext
        >
      >;
    };
    schema: UpdateFieldReportSchema;
    types: {
      parameters: UpdateFieldReportParameters;
      data: UpdateFieldReportData;
      error: UpdateFieldReportError;
      body: UpdateFieldReportBody;
    };
  };
  /** @summary Complete Field Report */
  completeFieldReport: {
    /** @summary Complete Field Report */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CompleteFieldReportBody,
        CompleteFieldReportParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CompleteFieldReportSchema,
        options: ServiceOperationMutationFnOptions<
          CompleteFieldReportBody,
          CompleteFieldReportParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CompleteFieldReportData, CompleteFieldReportError>>
    ): Promise<RequestFnResponse<CompleteFieldReportData, CompleteFieldReportError>>;
    /** @summary Complete Field Report */
    getMutationKey(
      parameters: DeepReadonly<CompleteFieldReportParameters> | void
    ): ServiceOperationMutationKey<CompleteFieldReportSchema, CompleteFieldReportParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Complete Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.completeFieldReport.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.completeFieldReport.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CompleteFieldReportBody, TContext = unknown>(
      parameters: DeepReadonly<CompleteFieldReportParameters>,
      options?: ServiceOperationUseMutationOptions<
        CompleteFieldReportSchema,
        CompleteFieldReportData,
        CompleteFieldReportParameters,
        TVariables,
        OperationError<CompleteFieldReportError>,
        TContext
      >
    ): UseMutationResult<
      CompleteFieldReportData,
      OperationError<CompleteFieldReportError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Complete Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.completeFieldReport.useMutation({
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.fieldReportService.completeFieldReport.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         service_event_id: serviceEventId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CompleteFieldReportBody, CompleteFieldReportParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CompleteFieldReportSchema,
        CompleteFieldReportData,
        CompleteFieldReportParameters,
        TVariables,
        OperationError<CompleteFieldReportError>,
        TContext
      >
    ): UseMutationResult<CompleteFieldReportData, OperationError<CompleteFieldReportError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Complete Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const completeFieldReportTotal = qraft.fieldReportService.completeFieldReport.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const completeFieldReportTotal = qraft.fieldReportService.completeFieldReport.useIsMutating({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CompleteFieldReportBody,
            CompleteFieldReportData,
            CompleteFieldReportParameters,
            OperationError<CompleteFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CompleteFieldReportSchema,
            CompleteFieldReportBody,
            CompleteFieldReportData,
            CompleteFieldReportParameters,
            OperationError<CompleteFieldReportError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Complete Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const completeFieldReportPendingMutationVariables = qraft.fieldReportService.completeFieldReport.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const completeFieldReportMutationData = qraft.fieldReportService.completeFieldReport.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 service_event_id: serviceEventId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CompleteFieldReportData,
        OperationError<CompleteFieldReportError>,
        MutationVariables<CompleteFieldReportBody, CompleteFieldReportParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CompleteFieldReportBody,
            CompleteFieldReportData,
            CompleteFieldReportParameters,
            OperationError<CompleteFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CompleteFieldReportSchema,
            CompleteFieldReportBody,
            CompleteFieldReportData,
            CompleteFieldReportParameters,
            OperationError<CompleteFieldReportError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CompleteFieldReportData,
          OperationError<CompleteFieldReportError>,
          MutationVariables<CompleteFieldReportBody, CompleteFieldReportParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Complete Field Report */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CompleteFieldReportBody,
            CompleteFieldReportData,
            CompleteFieldReportParameters,
            OperationError<CompleteFieldReportError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CompleteFieldReportSchema,
            CompleteFieldReportBody,
            CompleteFieldReportData,
            CompleteFieldReportParameters,
            OperationError<CompleteFieldReportError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Complete Field Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.fieldReportService.completeFieldReport.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             service_event_id: serviceEventId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.fieldReportService.completeFieldReport.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CompleteFieldReportBody,
              CompleteFieldReportData,
              CompleteFieldReportParameters,
              OperationError<CompleteFieldReportError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CompleteFieldReportSchema,
              CompleteFieldReportBody,
              CompleteFieldReportData,
              CompleteFieldReportParameters,
              OperationError<CompleteFieldReportError>,
              TContext
            >
      ):
        | Mutation<
            CompleteFieldReportData,
            CompleteFieldReportError,
            MutationVariables<CompleteFieldReportBody, CompleteFieldReportParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CompleteFieldReportBody,
              CompleteFieldReportData,
              CompleteFieldReportParameters,
              OperationError<CompleteFieldReportError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CompleteFieldReportSchema,
              CompleteFieldReportBody,
              CompleteFieldReportData,
              CompleteFieldReportParameters,
              OperationError<CompleteFieldReportError>,
              TContext
            >
      ): Array<
        Mutation<
          CompleteFieldReportData,
          CompleteFieldReportError,
          MutationVariables<CompleteFieldReportBody, CompleteFieldReportParameters>,
          TContext
        >
      >;
    };
    schema: CompleteFieldReportSchema;
    types: {
      parameters: CompleteFieldReportParameters;
      data: CompleteFieldReportData;
      error: CompleteFieldReportError;
      body: CompleteFieldReportBody;
    };
  };
}
/** @summary Get Field Report */
export const getFieldReport = {
  schema: {
    method: 'get',
    url: '/service_events/{service_event_id}/field_report/',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetFieldReportSchema;
  [QraftServiceOperationsToken]: FieldReportService['getFieldReport'];
};
/** @summary Create Field Report */
export const createFieldReport = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/field_report/',
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateFieldReportSchema;
  [QraftServiceOperationsToken]: FieldReportService['createFieldReport'];
};
/** @summary Update Field Report */
export const updateFieldReport = {
  schema: {
    method: 'put',
    url: '/service_events/{service_event_id}/field_report/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateFieldReportSchema;
  [QraftServiceOperationsToken]: FieldReportService['updateFieldReport'];
};
/** @summary Complete Field Report */
export const completeFieldReport = {
  schema: {
    method: 'post',
    url: '/service_events/{service_event_id}/field_report/complete',
    security: ['HTTPBearer'],
  },
} as {
  schema: CompleteFieldReportSchema;
  [QraftServiceOperationsToken]: FieldReportService['completeFieldReport'];
};
export const fieldReportService = {
  getFieldReport,
  createFieldReport,
  updateFieldReport,
  completeFieldReport,
} as const;
type GetFieldReportSchema = {
  method: 'get';
  url: '/service_events/{service_event_id}/field_report/';
  security: ['HTTPBearer'];
};
type GetFieldReportParameters = paths['/service_events/{service_event_id}/field_report/']['get']['parameters'];
type GetFieldReportData =
  paths['/service_events/{service_event_id}/field_report/']['get']['responses']['200']['content']['application/json'];
type GetFieldReportError =
  paths['/service_events/{service_event_id}/field_report/']['get']['responses']['422']['content']['application/json'];
type CreateFieldReportSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/field_report/';
  security: ['HTTPBearer'];
};
type CreateFieldReportParameters = paths['/service_events/{service_event_id}/field_report/']['post']['parameters'];
type CreateFieldReportData =
  paths['/service_events/{service_event_id}/field_report/']['post']['responses']['201']['content']['application/json'];
type CreateFieldReportError =
  paths['/service_events/{service_event_id}/field_report/']['post']['responses']['422']['content']['application/json'];
type CreateFieldReportBody = undefined;
type UpdateFieldReportSchema = {
  method: 'put';
  url: '/service_events/{service_event_id}/field_report/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateFieldReportParameters = paths['/service_events/{service_event_id}/field_report/']['put']['parameters'];
type UpdateFieldReportData =
  paths['/service_events/{service_event_id}/field_report/']['put']['responses']['200']['content']['application/json'];
type UpdateFieldReportError =
  paths['/service_events/{service_event_id}/field_report/']['put']['responses']['422']['content']['application/json'];
type UpdateFieldReportBody =
  paths['/service_events/{service_event_id}/field_report/']['put']['requestBody']['content']['application/json'];
type CompleteFieldReportSchema = {
  method: 'post';
  url: '/service_events/{service_event_id}/field_report/complete';
  security: ['HTTPBearer'];
};
type CompleteFieldReportParameters =
  paths['/service_events/{service_event_id}/field_report/complete']['post']['parameters'];
type CompleteFieldReportData =
  paths['/service_events/{service_event_id}/field_report/complete']['post']['responses']['200']['content']['application/json'];
type CompleteFieldReportError =
  paths['/service_events/{service_event_id}/field_report/complete']['post']['responses']['422']['content']['application/json'];
type CompleteFieldReportBody = undefined;
